<script>

import BasePage from "../my-components/base-page";
import util from '@/libs/util';
export default {
  name: "page-data",
  components: {BasePage},
  data() {
    return {
      table: {
        loading: false,
        data: [],
        page: {
          type:-1,
          current: 1,
          size: 10,
          total: 0,
          sortKey: 'id',
          sortMethod: 'desc',
          keyword:''
        }
      },
    };
  },
  computed: {
    getColumns() {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t("l.data_type"),
          align: 'center',
          render: (h, params) => {
            let type = params.row.type;
            return h('span', {
                },type == 0 ? '语音':type == 1? '参数':type == 2?'故障记录':type == 3 ? '照片':type == 4? "视频" :type == 5? '反馈':type == 6?'示波器曲线':type == 7 ?"记录仪数据":type == 8?'回传参数':type == 9?'文字':'故障分析数据'
            )
          }
        },
        {
          title: this.$t("l.file_size")+"(KB)",
          align: 'center',
          key:"fileSize",
        },
        {
          title: this.$t("l.extract_code"),
          align: 'center',
          key:"code",
        },
        {
          title: this.$t("l.help_seekers"),
          align: 'center',
          key:"sender",
        },
        {
          title: this.$t("l.seeking_help"),
          align: 'center',
          key:"receiver",
        },
        {
          title: this.$t("l.upload_time"),
          align: 'center',
          key:"updateTime",
        },
        {
          title: this.$t("l.download"),
          align: 'center',
          render: (h, params) => {
            let type = params.row.type;
            let id = params.row.id;
            return h('a', {
                  props: {
                  },
                  on: {
                    "click": () => {
                      if(type === 1 || type === 2 || type === 8 ){  // 参数

                        util.ajax.get('/dtzj/data/viewParams/'+id).then((res) => {
                          if(!res.code){
                            if(res.data){
                              // let content = res.data.join("\n");
                              this.$Modal.info({
                                title: this.$t("l.message_content"),
                                scrollable:true,
                                render: (h) => {

                                  let doms = res.data.map(elem => {
                                    return h("p",{},elem);
                                  });

                                  return h( "div", {
                                    style:{
                                      maxHeight:"400px",
                                      overflowY:'auto'
                                    }
                                  },doms)
                                }
                              });
                            }

                          }else{
                            this.$Message.error(this.$t("l.error"))
                          }
                        });


                      }else if(type === 9){  // 文字
                        this.$Modal.info({
                          title: this.$t("l.message_content"),
                          content: params.row.text
                        });
                      }else{  // 下载
                        location.href = "https://api.diantiyun.com/dtzj/api/download/"+id;
                      }
                    }
                  }
                },type === 1 || type === 2 || type === 8 || type === 9 ?this.$t("l.check"):this.$t("l.download")
            )
          }
        },
      ]
    },
    typeList(){
      return  [
        {
          value: -1,
          label: this.$t("l.all")
        },
        {
          value: 0,
          label: this.$t("l.voice")
        },
        {
          value: 1,
          label: this.$t("l.para")
        },
        {
          value: 2,
          label: this.$t("l.fault")
        },
        {
          value: 3,
          label: this.$t("l.fault")
        },
        {
          value: 4,
          label: this.$t("l.picture")
        },
        {
          value: 5,
          label: this.$t("l.feedback")
        },
        {
          value: 6,
          label: this.$t("l.oscilloscope_curve")
        },
        {
          value: 7,
          label: this.$t("l.recorder_data")
        },
        {
          value: 8,
          label: this.$t("l.return_parameters")
        },
        {
          value: 9,
          label: this.$t("l.text")
        },
        {
          value: 100,
          label: this.$t("l.fault_analysis")
        },
      ]
    }

  },
  methods: {
    loadData() {
      this.table.loading = true;
      util.ajax.get('/dtzj/data/list',{params:this.table.page}).then((res) => {
        this.table.loading = false;
        this.setPage(res.data);
      });
    },
    setPage(data){
      if(data ){
        this.table.data = data.list;
        this.table.page.total = data.totalRow;
      }
    },
    deleteData: function () {  // 删除所选数据
      let records = this.$refs.selection.getSelection();
      if(records.length){
        let ids = records.map(re=>re.id).join(",");
        this.$Modal.confirm({
          title: this.$t("l.warn"),
          content: this.$t("l.hint39"),
          onOk: () => {
            util.ajax.get('/dtzj/data/delete?ids='+ids).then((res) => {
              this.$Message.success(this.$t("l.success"));
              this.loadData();
            });
          },
          onCancel: () => {

          }
        });
      }else{
        this.$Message.error(this.$t("l.remark243"));
      }
    },

    // deleteAll(){
    //   this.$Modal.confirm({
    //     title: this.$t("l.warn"),
    //     content: this.$t("l.hint39"),
    //     onOk: () => {
    //
    //     },
    //     onCancel: () => {
    //
    //     }
    //   });
    // }
  },
  created() {
    this.loadData();

  },
}
</script>

<template>
  <BasePage :title="$t('l.data_manage')" icon="md-archive">
    <Row type="flex" justify="end" class="margin-t-b-10">
      <Col  class="margin-left-5">
        <Select v-model="table.page.type" style="width:200px" @on-change="loadData">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </Col>
      <Col  class="margin-left-5">
        <Input v-model="table.page.keyword" :placeholder="$t('l.remark67')" style="width: 300px" />
      </Col>
      <Col  class="margin-left-5">
        <Button type="primary"  @click="loadData(1)">{{$t('l.search')}} </Button>
      </Col>
      <Col  class="margin-left-5">
        <Button type="error"  @click="deleteData">{{$t('l.delete')}} </Button>
      </Col>
<!--      <Col  class="margin-left-5">-->
<!--        <Button type="error"  @click="deleteAll">{{$t('l.clear')}} </Button>-->
<!--      </Col>-->
    </Row>
    <Row class="full">
      <Table ref="selection" stripe border :columns="getColumns" :data="table.data" :loading="table.loading"></Table>
      <Row type="flex" justify="center">
        <Col>
          <Page size="small"
                :current="table.page.current"
                :page-size="table.page.size"
                :total="table.page.total"
                show-elevator show-sizer
                show-total
                @on-page-size-change="($event)=>{table.page.size = $event,loadData(1)}"
                @on-change="($event)=>{table.page.current = $event,loadData()}"></Page>
        </Col>
      </Row>
    </Row>
  </BasePage>
</template>

<style scoped lang="less">

</style>